import { render, staticRenderFns } from "./IncludeBannerCard.vue?vue&type=template&id=a057ea58&scoped=true"
import script from "./IncludeBannerCard.vue?vue&type=script&setup=true&lang=js"
export * from "./IncludeBannerCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./IncludeBannerCard.vue?vue&type=style&index=0&id=a057ea58&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a057ea58",
  null
  
)

export default component.exports